import FormuleFormConfigImpressionController from './formule.form.config.impression.controller';

export default {
    bindings: {
        formule: '='
    },
    template: require('./formule.form.config.impression.html'),
    controller: FormuleFormConfigImpressionController
};
